var React = require('react');

function LendingCritInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.5 0L5 6.499V6.8H6.396L11.5 1.697L16.8 6.996V12.781H14.2V13.981H18V6.499L11.5 0ZM11.5 8H1.5C0.675 8 0 8.675 0 9.5V11V12.2V16.5C0 17.325 0.675 18 1.5 18H11.5C12.325 18 13 17.325 13 16.5V12.2V11V9.5C13 8.675 12.325 8 11.5 8ZM11.8 16.5C11.8 16.663 11.663 16.8 11.5 16.8H1.5C1.337 16.8 1.2 16.663 1.2 16.5V12.2H11.8V16.5ZM11.8 11H1.2V9.5C1.2 9.337 1.337 9.2 1.5 9.2H11.5C11.663 9.2 11.8 9.337 11.8 9.5V11ZM10 14H8V15.2H10V14Z","fill":"#DB0011"}));
}

LendingCritInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","role":"img","aria-hidden":"true","focusable":"false"};

module.exports = LendingCritInline;

LendingCritInline.default = LendingCritInline;
